module.exports = __webpack_public_path__ + "img/info.8bbb0af1.svg";